<template>
  <div>
    <div class="ml-l pl-l">
      <el-button @click="$router.back()" size="small">返回</el-button>
    </div>
    <comp-wrap>
      <div>
        <div class="header-wrap">
          <div>
            <h3 class="my-l py-l">{{ map[order.status] || '非此商城的状态' }}</h3>
            <div>
              <span class="color2">订单号: {{ order.id }}</span>
              <span style="padding: 0 4px; margin-right: 5px;" class="member-tag" v-if="order.groupuuid">{{ '拼团 ID: ' + order.groupuuid + ' ' + (order.grouplead === 2 ? '团长代收' : '单独发货') }}</span>
              <span style="padding: 0 4px; margin-right: 5px;" class="member-tag" v-if="order.user.isvip == 2">会员</span>
              <span style="padding: 0 4px; margin-right: 5px;" class="member-tag">{{ order.user.nickname }}({{ order.user.mobile }})</span>
            </div>
          </div>
          <div class="header-action" v-if="order.status == 2">
            <el-button @click="updateOrder(3)" type="primary" size="small">
              确认发货
            </el-button>
            <div class="color3 mt-l pt-l">选择物流公司，即可确认发货</div>
          </div>
          <div class="header-action" v-if="order.status == 3">
            <el-button @click="updateOrder(2)" type="primary" size="small">
              取消运单
            </el-button>
            <div class="color3 mt-l pt-l">如果快递公司无法进行配送</div>
          </div>
        </div>
      </div>

      <div class="order-detail_banner" v-if="order.status === 12">
        <div class="detail-banner_text">
          <span>买家申请退款</span>
          <span class="detail-banner_sub-text">未发货状态下买家申请退款</span>
        </div>
        <div>
          <el-button @click="updateOrder(2)" size="small" type="info">拒绝退款</el-button>
          <el-button @click="updateOrder(8)" size="small" type="primary">确认退款</el-button>
        </div>
      </div>

      <div class="order-detail_banner" v-if="order.status === 2">
        <div class="detail-banner_text">
          <span>直接退款</span>
          <span class="detail-banner_sub-text">如果因为库存不足等原因无法发货, 您可以直接直接退款取消订单</span>
        </div>
        <div>
          <el-button @click="updateOrder(8)" size="small" type="info">直接退款</el-button>
        </div>
      </div>

      <div class="order-detail_banner" v-if="order.status === 7">
        <div class="detail-banner_text">
          <span>已同意买家退货申请</span>
          <span class="detail-banner_sub-text">等待买家寄回商品, 确认退回商品无问题后点击「确认收到」发起退款</span>
        </div>
        <div>
          <el-button @click="updateOrder(11)" size="small" type="info">未收到</el-button>
          <el-button @click="updateOrder(8)" size="small" type="primary">确认收到</el-button>
        </div>
      </div>

      <div class="order-detail_banner" v-if="order.status === 9">
        <div class="detail-banner_text">买家申请退货</div>
        <div>
          <el-button @click="updateOrder(7)" size="small" type="info">同意退货</el-button>
          <el-button @click="updateOrder(10)" size="small" type="primary">拒绝退货</el-button>
        </div>
      </div>

      <div class="address-box">
        <h5 class="mb-l pb-l mt-s pt-s">配送信息</h5>
        <el-row align="middle" type="flex">
          <el-col class="color1" span="2">配送地址</el-col>
          <el-col class="color1" offset="1" span="6">{{ order.address.name }}, {{ order.address.mobile }}</el-col>
        </el-row>
        <el-row align="middle" style="margin-top: 5px;" type="flex">
          <el-col span="2">
            <el-button size="small" style="padding: 2px 10px; font-size: 10px;" type="info">复制</el-button>
          </el-col>
          <el-col class="color1" offset="1" span="6">{{ order.address.province }} {{ order.address.city }} {{ order.address.district }} {{ order.address.address }}</el-col>
        </el-row>
        <el-row align="middle" style="margin-top: 5px;" type="flex" v-if="order.status === 2">
          <el-col class="color1 my" span="1">物流信息</el-col>
          <el-col offset="1" span="3">
            <el-select placeholder="请选择物流公司" v-model="shipindex">
              <el-option :key="index" :label="item.deliveryname + '-' + item.servicename+'-' + item.bizid" :value="index" v-for="(item, index) in shiplist"></el-option>
            </el-select>
          </el-col>
        </el-row>
      </div>

      <comp-list :text="order.shippingcompany" label="发货物流公司" v-if="order.shippingcompany" />
      <comp-list :text="order.shippingnumber" gutter label="发货物流单号" v-if="order.shippingnumber" />
      <comp-list :text="order.returnshippingcompany" label="退货物流公司" v-if="order.returnshippingcompany" />
      <comp-list :text="order.returnshippingnumber" gutter label="退货物流单号" v-if="order.returnshippingnumber" />

      <comp-list :text="`¥ ${$amount1(order.amount)}`" label="商品合计" />
      <comp-list :text="getCoupon(order.coupon)" label="使用优惠券" v-if="order.couponid" />
      <comp-list :text="`¥ ${$amount1(order.originfreight)}`" label="配送费" />
      <comp-list :key="marketing.id" :label="getMarketingLabel(marketing)" :text="getMarketing(marketing)" v-for="marketing in order.marketinglist" />
      <comp-list :text="`¥ ${$amount1(order.actualamount + order.freight)}`" gutter label="实际支付" />
      <comp-list :gutter="!order.needinvoice" :text="order.note" label="买家备注" />
      <comp-list :text="order.giftnote" label="礼卡祝福语" />
      <comp-list :text="order.invoice.kind === 0 ? '个人' : '单位'" label="发票类型" nomb v-if="order.needinvoice == 1" />
      <comp-list :text="order.invoice.name" label="发票抬头" nomb v-if="order.needinvoice == 1" />
      <comp-list :text="order.invoice.taxid" gutter label="发票税号" nomb v-if="order.needinvoice == 1" />

      <div class="g-b" style="border: 1px solid #e9e9e9; margin-left: -10px; margin-right: -10px;">
        <div class="product" :key="oproduct.id" v-for="oproduct in order.orderproductsList">
          <div class="product-info">
            <div class="product-img" @click="$router.push({ name: 'products-edit', query: { id: oproduct.productid, type: 'edit' } })">
              <comp-imger :src="oproduct.product.imagesList.length ? oproduct.product.imagesList[0] : ''" />
            </div>
            <div>
              <div class="product-name">{{ oproduct.product.name }}</div>
              <div class="product-desc">{{ oproduct.optionname && '(' + Object.values(JSON.parse(oproduct.optionname)).join(', ') + ')' }}</div>
            </div>
          </div>
          <div class="price">{{ $amount1(oproduct.amount) }} 元</div>
          <div class="count">{{ oproduct.quantity }} 个</div>
        </div>
      </div>

      <comp-list :text="new Date(order.createdat * 1000).toLocaleString('zh-CN', { timeZone: 'Asia/Shanghai' })" label="下单时间" />
      <comp-list :text="new Date(order.updatedat * 1000).toLocaleString('zh-CN', { timeZone: 'Asia/Shanghai' })" label="最后更新" />
      <comp-list :text="new Date(order.paidat * 1000).toLocaleString('zh-CN', { timeZone: 'Asia/Shanghai' })" label="支付时间" v-if="order.status != 0 && order.status != 6" />
      <comp-list :text="order.transactionid" label="微信流水号" v-if="order.payway == 1" />
      <comp-list v-if="order.payway == 1" text="微信支付" label="支付方式" />
      <comp-list v-if="order.payway == 2" text="余额支付" label="支付方式" />

      <comp-list v-if="order.brokeragestatus === 0" text="无" label="有无分账" />
      <comp-list v-if="order.brokeragestatus !== 0" text="有" label="有无分账" />

      <comp-list v-if="order.profitsharinguserid" :text="order.profitsharinguser.nickname + '(' + order.profitsharinguser.mobile + ')'" label="分销员" />
      <comp-list v-if="order.brokerage !== 0" :text="order.brokerage / 100" label="分销员佣金" />

      <comp-list v-if="order.brokeragestatus === 1 && (order.status == 0 || order.status == 1 || order.status == 2 || order.status == 3 || order.status == 4)" text="未结算" label="分账结算" />
      <comp-list v-if="order.brokeragestatus === 2" text="已结算" label="分账结算" />
      <comp-list v-if="order.brokeragestatus === 3" text="未结算(结算失败)" label="分账结算" />
      <comp-list v-if="order.brokeragestatus === 1 && !(order.status == 0 || order.status == 1 || order.status == 2 || order.status == 3 || order.status == 4)" text="未结算(结算无效)" label="分账结算" />
    </comp-wrap>
  </div>
</template>

<script>
/* eslint-disable */
import { Message } from 'element-ui';
import { M } from '../../../service/grpc.js';
import { rpc } from '../../../service/index.js';
import { getToken } from '../../../service/helper.js';

let token = '';

const CompWrap = {
  functional: true,
  render(h, context) {
    return (
      <div class="container">
        <div class="wrap">{context.children}</div>
      </div>
    );
  }
};

const CompList = {
  functional: true,
  props: ['label', 'text', 'gutter', 'nomb'],
  render(h, context) {
    const { label, text, gutter, nomb } = context.props;
    const arr = ['info'];

    if (gutter !== undefined) arr.push('g-b');
    if (nomb !== undefined && gutter === undefined) arr.push('nomb');

    return (
      <div class={arr.join(' ')}>
        <div class="color1 mr-l pr-l title">{label}</div>
        <div class="color1 ml-l pl-l text">{text}</div>
      </div>
    );
  }
};

const map = {
  '0': '等待买家支付',
  '1': '拼团中',
  '2': '待发货',
  '3': '等待买家收货',
  '4': '买家已收货',
  '5': '团购失败',
  '6': '买家已取消订单',
  '7': '退货中',
  '8': '已退款',
  '9': '买家申请退货',
  '10': '拒绝买家退货',
  '11': '同意退货但拒绝退款',
  '12': '买家申请退款'
};

export default {
  components: {
    'comp-list': CompList,
    'comp-wrap': CompWrap
  },
  data() {
    return {
      shiplist: [],
      shipindex: null,
      map,
      order: {
        address: {},
        invoice: {},
        marketinglist: [],
        orderproductsList: [],
        user: {},
        coupon: {}
      }
    };
  },
  async created() {
    token = getToken();

    rpc(
      'StoreDeliveryService.GetOrderWxDeliveryList',
        M('Token', { token: token })
    ).then(res => {
      this.shiplist = res.wxdeliverylistList;
    });

    const { id } = this.$route.query;

    // 获取订单
    const res = await rpc(
      'StoreOrderService.GetOrder',
      M('IDWithTokenRequest', {
        token: M('Token', { token }),
        id: id
      })
    );
    // 完善订单里的关联资源
    let productidlist = res.orderproductsList.map(v => v.productid);
    let reslist = await Promise.all([
      rpc(
        'StoreUserService.GetUser',
        M('IDWithTokenRequest', {
          token: M('Token', { token }),
          id: res.userid
        })
      ),
      rpc(
        'StoreProductService.GetProductList',
        M('ProductListQueryRequest', {
          token: M('Token', { token }),
          idlistList: productidlist,
          sortby: 1,
          sort: 1,
          count: productidlist.length
        })
      ),
      res.marketingidsList.length
        ? rpc(
            'StoreMarketingService.GetMarketingList',
            M('MarketingListQueryRequest', {
              token: M('Token', { token }),
              kind: -1,
              idlistList: res.marketingidsList,
              sortby: 1,
              sort: 1,
              count: res.marketingidsList.length
            })
          )
        : null,
      res.couponid
        ? rpc(
            'StoreCouponService.GetCoupon',
            M('IDWithTokenRequest', {
              token: M('Token', { token }),
              id: res.couponid
            })
          )
        : null,
      res.profitsharinguserid
        ? rpc(
            'StoreUserService.GetUser',
            M('IDWithTokenRequest', {
              token: M('Token', { token }),
              id: res.profitsharinguserid
            })
          )
        : null
    ]);
    res.user = reslist[0];
    res.orderproductsList.forEach(item => {
      item.product = reslist[1].productlistList.find(v => v.id === item.productid);
    });
    res.marketinglist = reslist[2] ? reslist[2].marketinglistList : [];
    res.coupon = reslist[3];
    res.profitsharinguser = reslist[4];
    productidlist = [];
    const coupontemplateidlist = [];
    res.marketinglist.forEach(item => {
      if (item.kind !== 2) {
        return;
      }
      if (item.gifttype === 0) {
        coupontemplateidlist.push(item.giftid);
      }
      if (item.gifttype === 1) {
        productidlist.push(item.giftid);
      }
    });
    reslist = await Promise.all([
      coupontemplateidlist.length
        ? rpc(
            'StoreCouponTemplateService.GetCouponTemplateList',
            M('CouponTemplateListQueryRequest', {
              token: M('Token', { token }),
              idlistList: coupontemplateidlist,
              count: coupontemplateidlist.length
            })
          )
        : null,
      productidlist.length
        ? rpc(
            'StoreProductService.GetProductList',
            M('ProductListQueryRequest', {
              token: M('Token', { token }),
              idlistList: productidlist,
              sortby: 1,
              sort: 1,
              count: productidlist.length
            })
          )
        : null
    ]);
    res.marketinglist.forEach(item => {
      item.coupontemplate = null;
      item.product = null;
      if (item.kind !== 2) {
        return;
      }
      if (item.gifttype === 0) {
        item.coupontemplate = reslist[0] ? reslist[0].coupontemplatelistList.find(v => v.id === item.giftid) : null;
      }
      if (item.gifttype === 1) {
        item.product = reslist[1] ? reslist[1].productlistList.find(v => v.id === item.giftid) : null;
      }
    });
    this.order = res;
  },

  methods: {
    async updateOrder(status) {
        try{
            if(this.order.status==3 && status === 2 && this.order.shippingnumber != ''){
              await this.$confirm('如果再次发货此订单只能选择商家自配送, 确认取消?', '确认取消运单?', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
              })
            }
        }catch(e){
            return;
        }
      const row = JSON.parse(JSON.stringify(this.order));
      row.status = status;
      if (status === 3) {
        if (this.shipindex === null) {
          this.$message({
            message: '请选择物流公司',
            type: 'error'
          });
          return;
        }
        row.shippingcompany = this.shiplist[this.shipindex].deliveryname + '-' + this.shiplist[this.shipindex].servicename;
      }
      rpc(
        'StoreOrderService.UpdateOrder',
        M('OrderWithTokenRequest', {
          token: M('Token', { token }),
          order: M('Order', {
            ...row,
            address: M('Address', row.address),
            invoice: M('Invoice', row.invoice),
            orderproductsList: row.orderproductsList.map(v => M('OrderProduct', v))
          }),
          ...this.shiplist[this.shipindex]
        })
      ).then(res => {
        this.order.status = res.status;
        this.order.shippingcompany = res.shippingcompany;
        this.order.shippingnumber = res.shippingnumber;
        this.order.updatedat = res.updatedat;
        this.$message({
          message: '操作成功',
          type: 'success'
        });
      });
    },
    getCoupon(coupon) {
      return `¥ -${this.$amount1(coupon.amount)} (满${this.$amount1(coupon.reach)}减${this.$amount1(coupon.amount)})`;
    },
    getMarketing(marketing) {
      if (marketing.kind === 1) {
        return `¥ -${this.$amount1(marketing.reduction)} (满${this.$amount1(marketing.reach)}减${this.$amount1(marketing.reduction)})`;
      }
      if (marketing.kind === 2) {
        if (marketing.gifttype === 1) {
          return `满${this.$amount1(marketing.reach)}赠商品: ${marketing.product.name}`;
        }
        let amountstr = '';
        if (marketing.coupontemplate.amount === 0) {
          amountstr = `¥ ${marketing.coupontemplate.amountbegin / 100} ~ ¥ ${marketing.coupontemplate.amountend / 100}`;
        }
        if (marketing.coupontemplate.amount === 1) {
          amountstr = `¥ ${marketing.coupontemplate.amount / 100}`;
        }
        return `满${this.$amount1(marketing.reach)}赠优惠券: ${marketing.coupontemplate.name}(${amountstr})`;
      }
      return `¥ -${this.$amount1(this.order.originfreight)} (满${this.$amount1(marketing.reach)}免运费)`;
    },
    getMarketingLabel(marketing) {
      const map = { 1: '满减优惠', 2: '满赠优惠', 3: '满免运费' };
      return map[marketing.kind];
    }
  }
};
</script>

<style lang="scss" scoped>
.wrap {
  padding: 10px;
  padding-top: 0;
}
.address-box {
  margin: 15px -10px;
  background-color: #f8f8f8;
  padding: 10px;
}
.info {
  display: flex;
  flex-direction: row;
  margin-bottom: 10px;
}
.title {
  line-height: 20px;
  width: 80px;
  font-weight: bold;
}
.text {
  line-height: 20px;
}
.g-b {
  margin-bottom: 25px;
}
.nomb {
  margin-bottom: 0;
}
</style>

<style lang="scss">
.header-wrap {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}
.header-action {
  text-align: right;
}
.order-detail_banner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 10px;
  background-color: #ffe9e9;
  margin: 0 -10px;
  margin-top: 20px;
}
.detail-banner_text {
  font-size: 14px;
  color: #ff4f4f;
  display: flex;
  flex-direction: column;
}
.detail-banner_sub-text {
  margin-top: 5px;
  color: #999;
  font-size: 12px;
}
.member-tag {
  font-size: 10px;
  color: #ff4f4f;
  background-color: #f0dcdc;
  width: 36px;
  text-align: center;
  line-height: 18px;
  border-radius: 3px;
}
.product {
  display: flex;
  border-bottom: 1px solid #e9e9e9;
}
.product:last-child {
  border-bottom: none;
}
.product-info {
  padding: 10px;
  display: flex;
  flex: 1;
}
.product-img {
  width: 80px;
  height: 80px;
  margin-right: 10px;
  & > img {
    width: 80px;
    height: 80px;
  }
}
.product-name {
  margin-top: 10px;
  font-weight: bold;
  font-size: 14px;
  color: #333;
}
.product-desc {
  margin-top: 10px;
  font-size: 12px;
  color: #666;
}
.price,
.count {
  display: flex;
  width: 100px;
  align-items: center;
  justify-content: center;
  border-left: 1px solid #e9e9e9;
}
</style>
